module.exports = __webpack_public_path__ + "static/footer-circle-5dfad97187723ab68f1db0225dd20097.svg";